import { type JoinOrSignInStateMachineContext } from '../join-or-sign-in-machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const initialContext: JoinOrSignInStateMachineContext = {
  email: undefined,
  accessToken: undefined,
  refreshToken: undefined,
  createAccountInput: undefined,
};
